import { SHOW_NOTIFICATION, CLEAR_NOTIFICATION } from 'actions/Types';

function notification(state = { show: false }, action) {
  if ([SHOW_NOTIFICATION, CLEAR_NOTIFICATION].includes(action.type)) {
    return action.payload;
  }

  return state;
}

export default notification;
